/* eslint semi:0 */
import BaseClass from 'application/BaseClass'
import brightcovePlayerStore from 'stores/brightcovePlayerStore'

export default class BrightcoveBasePlayerController extends BaseClass {

  constructor(options = {}){
    super(options)
    let store = options.store || brightcovePlayerStore
    this.merge({
      vm: this.vmClass.create(Object.assign({ store, }, options)),
    });
  }

  get vmClass(){ throw new Error('Must implement static get vmClass() on subclass') }

}


// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/controllers/BrightcoveBasePlayerController.js